import './styles/global.css';
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom';
import { HomePage } from './components/Pages/HomePage';
import { NotFound } from './components/Pages/NotFound';
import { GlobalProvider } from './contexts/states/GlobalState';
import { DashboardRoutes } from './components/Pages/Dashboard pages/DashboardRoutes';
import { HelmetProvider, Helmet } from 'react-helmet-async';
import { LoginPage } from './components/Pages/LoginPage';
import { RegisterPage } from './components/Pages/RegisterPage';
import { FeedbackPage } from './components/Pages/FeedbackPage';
import { DriverPage } from './components/Pages/DriverPage';
import { DownloadPage } from './components/Pages/DownloadPage';
import { PolicyPage } from './components/Pages/PolicyPage';
import { AboutPage } from './components/Pages/AboutPage';
import { LocationsPage } from './components/Pages/LocationsPage';

function App() {
  return (
    <HelmetProvider>
      <Helmet>
        <title>LionTaxi - Transportation made easy</title>
      </Helmet>
      <GlobalProvider>
        <Router>
          <Switch>
            <Route path='/' exact component={HomePage} />
            <Route path='/drivers' exact component={DriverPage} />
            <Route path='/about' exact component={AboutPage} />
            <Route path='/download' exact component={DownloadPage} />
            <Route path='/locations' exact component={LocationsPage} />
            <Route path='/privacy' exact component={PolicyPage} />
            <Route path='/policy' exact component={PolicyPage} />
            <Route path='/feedback' component={FeedbackPage} />
            <Route
              path='/hello-world'
              component={() => {
                return <h2>Hello world!</h2>;
              }}
            />
            <Route exact path='/admin' component={LoginPage} />
            <Route path='/admin/register' component={RegisterPage} />
            <Route path='/admin/dashboard' component={DashboardRoutes} />
            <Route component={NotFound} />
          </Switch>
        </Router>
      </GlobalProvider>
    </HelmetProvider>
  );
}

export default App;
